// Phân phối chương trình (PPCT) chuẩn — xương sống tổ chức nội dung.
// Xây từ manifest bài học hiện có + tên chương/bài tiếng Việt chính thức.
// KHÔNG sửa dữ liệu gốc; chỉ mô tả cấu trúc để chọn bằng combobox.
import { listCurriculum } from '../integrations/existingCurriculum'

// Tên chương theo "lop-chuong".
const CHAPTER_NAMES: Record<string, string> = {
  '10-0': 'Mở đầu',
  '10-1': 'Động học',
  '10-2': 'Động lực học',
  '10-3': 'Năng lượng và công',
  '10-4': 'Chuyển động tròn và biến dạng',
  '11-1': 'Dao động',
  '11-2': 'Sóng',
  '11-3': 'Điện trường',
  '11-4': 'Dòng điện. Mạch điện',
  '12-1': 'Vật lí nhiệt',
  '12-2': 'Khí lí tưởng',
  '12-3': 'Từ trường',
  '12-4': 'Vật lí hạt nhân',
}

// Tên bài (key = phần slug sau "bai-N-", thay '-' bằng ' ', viết thường).
const LESSON_NAMES: Record<string, string> = {
  'gioi thieu muc dich hoc tap mon vat li': 'Giới thiệu mục đích học tập môn Vật lí',
  'do dich chuyen va quang duong di duoc': 'Độ dịch chuyển và quãng đường đi được',
  'toc do va van toc chuyen dong tong hop': 'Tốc độ và vận tốc - Chuyển động tổng hợp',
  'do thi do dich chuyen thoi gian': 'Đồ thị độ dịch chuyển - thời gian',
  'chuyen dong bien doi': 'Chuyển động biến đổi',
  'chuyen dong roi tu do': 'Chuyển động rơi tự do',
  'chuyen dong nem': 'Chuyển động ném',
  'ba dinh luat newton ve chuyen dong': 'Ba định luật Newton về chuyển động',
  'mot so luc trong thuc tien': 'Một số lực trong thực tiễn',
  'tong hop luc va phan tich luc': 'Tổng hợp lực và phân tích lực',
  'can bang luc moment luc': 'Cân bằng lực - Moment lực',
  'khoi luong rieng ap suat chat long': 'Khối lượng riêng - Áp suất chất lỏng',
  'cong va nang luong': 'Công và năng lượng',
  'dong nang va the nang': 'Động năng và thế năng',
  'cong suat va hieu suat': 'Công suất và hiệu suất',
  'dong luong dinh luat bao toan dong luong': 'Động lượng - Định luật bảo toàn động lượng',
  'dong luong va va cham': 'Động lượng và va chạm',
  'dong hoc chuyen dong tron deu': 'Động học chuyển động tròn đều',
  'gia toc huong tam va luc huong tam': 'Gia tốc hướng tâm và lực hướng tâm',
  'su bien dang dinh luat hooke': 'Sự biến dạng - Định luật Hooke',
  'dao dong dieu hoa phuong trinh dao dong dieu hoa': 'Dao động điều hòa - Phương trình dao động điều hòa',
  'van toc gia toc trong dao dong dieu hoa': 'Vận tốc - Gia tốc trong dao động điều hòa',
  'nang luong trong dao dong dieu hoa': 'Năng lượng trong dao động điều hòa',
  'dao dong tat dan cuong buc cong huong': 'Dao động tắt dần - Cưỡng bức - Cộng hưởng',
  'mo ta song su truyen song': 'Mô tả sóng - Sự truyền sóng',
  'cac dac trung cua song song doc va song ngang': 'Các đặc trưng của sóng - Sóng dọc và sóng ngang',
  'song dien tu': 'Sóng điện từ',
  'giao thoa song': 'Giao thoa sóng',
  'song dung': 'Sóng dừng',
  'do toc do truyen am': 'Đo tốc độ truyền âm',
  'luc tuong tac giua cac dien tich dinh luat coulomb': 'Lực tương tác giữa các điện tích - Định luật Coulomb',
  'khai niem dien truong dien truong deu': 'Khái niệm điện trường - Điện trường đều',
  'dien the va the nang dien': 'Điện thế và thế năng điện',
  'dien dung va tu dien nang luong dien truong': 'Điện dung và tụ điện - Năng lượng điện trường',
  'dong dien cuong do dong dien': 'Dòng điện - Cường độ dòng điện',
  'dien tro dinh luat ohm': 'Điện trở - Định luật Ohm',
  'nguon dien': 'Nguồn điện',
  'nang luong dien cong suat dien': 'Năng lượng điện - Công suất điện',
  'su chuyen the': 'Sự chuyển thể',
  'noi nang dinh luat 1 cua nhiet dong luc hoc': 'Nội năng - Định luật 1 nhiệt động lực học',
  'thang nhiet do nhiet ke': 'Thang nhiệt độ - Nhiệt kế',
  'nhiet dung rieng': 'Nhiệt dung riêng',
  'nhiet nong chay rieng': 'Nhiệt nóng chảy riêng',
  'nhiet hoa hoi rieng': 'Nhiệt hóa hơi riêng',
  'mo hinh dong hoc phan tu chat khi': 'Mô hình động học phân tử chất khí',
  'dinh luat boyle': 'Định luật Boyle',
  'dinh luat charles': 'Định luật Charles',
  'phuong trinh trang thai cua khi li tuong': 'Phương trình trạng thái của khí lí tưởng',
  'ap suat theo mo hinh dong hoc phan tu dong nang phan tu': 'Áp suất theo mô hình động học phân tử - Động năng phân tử',
  'tu truong': 'Từ trường',
  'luc tu tac dung len doan day dan mang dong dien cam ung tu': 'Lực từ - Cảm ứng từ',
  'tu thong hien tuong cam ung dien tu': 'Từ thông - Hiện tượng cảm ứng điện từ',
  'may phat dien xoay chieu dai cuong ve dong dien xoay chieu': 'Máy phát điện xoay chiều - Đại cương dòng điện xoay chiều',
  'ung dung cua hien tuong cam ung dien tu': 'Ứng dụng hiện tượng cảm ứng điện từ',
  'dien tu truong mo hinh song dien tu': 'Điện từ trường - Mô hình sóng điện từ',
  'cau truc hat nhan': 'Cấu trúc hạt nhân',
  'do hut khoi va nang luong lien ket hat nhan': 'Độ hụt khối và năng lượng liên kết hạt nhân',
  'su phan hach va tong hop hat nhan': 'Sự phân hạch và tổng hợp hạt nhân',
  'phong xa an toan phong xa': 'Phóng xạ - An toàn phóng xạ',
  'cong nghiep hat nhan': 'Công nghiệp hạt nhân',
}

export interface LessonSlot {
  bai: number
  ten: string
  path: string
}
export interface ChapterNode {
  chuong: number
  ten: string
  lessons: LessonSlot[]
}
export interface GradeNode {
  lop: number
  chapters: ChapterNode[]
}

function lessonName(path: string): string {
  const last = path.split('/').pop() || ''
  const key = last.replace(/^bai-\d+-/, '').replace(/-/g, ' ').toLowerCase()
  if (LESSON_NAMES[key]) return LESSON_NAMES[key]
  const pretty = key.charAt(0).toUpperCase() + key.slice(1)
  return pretty
}

// Xây cây PPCT từ manifest.
function buildCurriculum(): GradeNode[] {
  const items = listCurriculum()
  const grades: Record<number, GradeNode> = {}
  for (const it of items) {
    const g = (grades[it.lop] ||= { lop: it.lop, chapters: [] })
    let ch = g.chapters.find((c) => c.chuong === it.chuong)
    if (!ch) {
      ch = { chuong: it.chuong, ten: CHAPTER_NAMES[`${it.lop}-${it.chuong}`] || `Chương ${it.chuong}`, lessons: [] }
      g.chapters.push(ch)
    }
    ch.lessons.push({ bai: it.bai, ten: lessonName(it.path), path: it.path })
  }
  const result = Object.values(grades).sort((a, b) => a.lop - b.lop)
  result.forEach((g) => {
    g.chapters.sort((a, b) => a.chuong - b.chuong)
    g.chapters.forEach((c) => c.lessons.sort((a, b) => a.bai - b.bai))
  })
  return result
}

export const CURRICULUM: GradeNode[] = buildCurriculum()

export const GRADES: number[] = CURRICULUM.map((g) => g.lop)

export function getChapters(lop: number): ChapterNode[] {
  return CURRICULUM.find((g) => g.lop === lop)?.chapters || []
}

export function getLessons(lop: number, chuong: number): LessonSlot[] {
  return getChapters(lop).find((c) => c.chuong === chuong)?.lessons || []
}

export function findChapterName(lop: number, chuong: number): string {
  return CHAPTER_NAMES[`${lop}-${chuong}`] || `Chương ${chuong}`
}
